import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import {
  getAllCustomTemplates,
  deleteCustomTemplate,
  updateCustomTemplate,
} from '../actions/PortConfig';
import CustomTemplateList from './CustomTemplateList';
import CustomTemplateEditModal from './CustomTemplateEditModal.js';

const CutstomTemplate = ({
  boxDetails,
  getAllCustomTemplates,
  deleteCustomTemplate,
  updateCustomTemplate,
}) => {
  const [sort, setSort] = useState({
    name: '',
    order: '',
  });

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isPortConfigModalOpen, setIsPortConfigModalOpen] = useState(false);
  const [selectedTemplateForEdit, setSelectedTemplateForEdit] = useState(null);
  const [data, setData] = useState({
    docs: [],
    totalPages: 0,
    page: 1,
    totalDocs: 0,
    limit: 10,
  });

  const token = localStorage.getItem('jwtToken') || null;

  useEffect(() => {
    const fetchTemplates = async () => {
      const dc = boxDetails?.datacenter || '';
      const response = await getAllCustomTemplates(token, page, limit);

      setData(
        response || {
          docs: [],
          totalPages: 0,
          page: 1,
          totalDocs: 0,
          limit: 10,
        }
      );
    };

    fetchTemplates();
  }, [boxDetails, getAllCustomTemplates, token, page, limit]);

  const handleSort = sortName => {
    setSort(prev => {
      if (prev.name === sortName) {
        return {
          ...prev,
          order: prev.order === 'asc' ? 'desc' : 'asc',
        };
      }

      return {
        name: sortName,
        order: 'asc',
      };
    });
  };

  const handleChangePagination = newPage => {
    setPage(newPage);
  };

  const handleSetLimit = newLimit => {
    const parsedLimit = Number(newLimit) || 10;
    setLimit(parsedLimit);
    setPage(1);
  };

  const mappedTemplates = useMemo(() => {
    const list = (data?.docs || []).map(item => ({
      ...item,
      companyName: item?.companyBox?.name || '-',
      lineType: item?.name || '-',
      displayName: item?.title || '-',
    }));

    if (!sort.name) return list;

    return orderBy(
      list,
      [
        row => {
          if (sort.name === 'companyBox.name') {
            return (row?.companyBox?.name || '').toString().toLowerCase();
          }

          return (row?.[sort.name] || '').toString().toLowerCase();
        },
      ],
      [sort.order]
    );
  }, [data, sort]);

  const handleView = template => {
    setSelectedTemplateForEdit(template);
    setIsPortConfigModalOpen(true);
  };

  const handleDelete = async template => {
    const dc = boxDetails?.datacenter || '';
    const response = await deleteCustomTemplate(token, template._id);
    if (response) {
      const updatedData = await getAllCustomTemplates(
        token,
        data.page,
        data.limit
      );

      setData(updatedData);
    }
  };

  return (
    <>
      <div className="viewContainer" style={{ marginTop: '20px' }}>
        <CustomTemplateList
          templates={mappedTemplates}
          totalPages={data?.totalPages || 0}
          page={data?.page || page}
          totalDocs={data?.totalDocs || 0}
          limit={data?.limit || limit}
          onSort={handleSort}
          sortValue={sort}
          onView={handleView}
          onDelete={handleDelete}
          onSetLimit={handleSetLimit}
          onChangePagination={handleChangePagination}
        />
      </div>

      <CustomTemplateEditModal
        isOpen={isPortConfigModalOpen}
        isClose={didUpdate => {
          setIsPortConfigModalOpen(false);
          setSelectedTemplateForEdit(null);

          if (didUpdate) {
            getAllCustomTemplates(
              token,
              page,
              limit
            ).then(response => {
              setData(
                response || {
                  docs: [],
                  totalPages: 0,
                  page: 1,
                  totalDocs: 0,
                  limit: 10,
                }
              );
            });
          }
        }}
        templateData={selectedTemplateForEdit}
        updateCustomTemplate={(id, payload) =>
          updateCustomTemplate(token, id, payload)
        }
      />
    </>
  );
};

const mapStateToProps = state => ({
  templates: state.AppState.portConfigTemplates?.data || [],
  boxDetails: state.AppState.boxDetails || {},
});

const mapDispatchToProps = dispatch => ({
  getAllCustomTemplates: (token, page, limit) =>
    dispatch(getAllCustomTemplates(token, page, limit)),

  deleteCustomTemplate: (token, id) =>
    dispatch(deleteCustomTemplate(token, id)),

  updateCustomTemplate: (token, id, payload) =>
    dispatch(updateCustomTemplate(token, id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CutstomTemplate);